import { createAction } from './utils'

export const SET_ERRORS = 'SET_ERRORS'
export const setErrors = createAction(SET_ERRORS, ['ids'])

export const SET_ERROR = 'SET_ERROR'
export const setError = createAction(SET_ERROR, ['id'])

export const REMOVE_ERROR = 'REMOVE_ERROR'
export const removeError = createAction(REMOVE_ERROR, ['id'])

export const RESET_ERRORS = 'RESET_ERRORS'
export const resetErrors = createAction(RESET_ERRORS)

export const STOP_WATCHING_ERRORS = 'STOP_WATCHING_ERRORS'
export const stopWatchingErrors = createAction(STOP_WATCHING_ERRORS)

export const SET_DIRTY = 'SET_DIRTY'
export const setDirty = createAction(SET_DIRTY, ['id'])

export const REMOVE_DIRTY = 'REMOVE_DIRTY'
export const removeDirty = createAction(REMOVE_DIRTY, ['id'])

export const RESET_DIRTY = 'RESET_DIRTY'
export const resetDirty = createAction(RESET_DIRTY)
